import { IAllPermission } from "@/store/PermissionStore";
import { tableColumns } from "@/pages/authorization-management/components/auth-detail-table/config/table-columns";
import { IAuthDetailTableData } from "@/pages/authorization-management/components/auth-detail-table/hooks/useAuthDetailTable";

export function getPermissionTableColumn(allPermission: IAllPermission[]) {
  const expandIndexMap = new Map();
  allPermission.forEach((module) => {
    if (module.children.length > 1) {
      expandIndexMap.set(expandIndexMap.size, module.children.length);
      module.children.forEach((_, i) => {
        if (i === 0) return;
        expandIndexMap.set(expandIndexMap.size, 0);
      });
    } else {
      expandIndexMap.set(expandIndexMap.size, 1);
    }
  });
  return tableColumns.map((item, i) => {
    if (item.key !== "module") return item;
    const onCell = (_: IAuthDetailTableData, index?: number) => ({
      rowSpan: expandIndexMap.get(index),
      colSpan: expandIndexMap.get(index) ? 1 : 0,
    });
    item.onCell = onCell;
    return item;
  });
}

export function getPermissionTableData(allPermission: IAllPermission[]) {
  return allPermission.reduce((result, module) => {
    module.children.forEach((authObject) => {
      const permissions = authObject.children.map((item) => ({
        id: item.id,
        authority: item.authority,
      }));
      result.push({
        moduleAuthority: module.authority,
        authObject: {
          id: authObject.id,
          authority: authObject.authority,
        },
        permissions,
      });
    });
    return result;
  }, [] as IAuthDetailTableData[]);
}
